var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('signinModal',{on:{"massActionSigninHandler":_vm.massActionSigninHandler}}),_c('b-modal',{attrs:{"id":"pageLoader","hide-footer":"","hide-header":"","size":"sm","no-close-on-esc":"","title":"Page loader"}},[_c('PageLoader')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }